import React, { useMemo } from "react";
import ReportManager, {
  groupByCurrency,
} from "commons/components/ReportManager";
import useQueryAllResources from "commons/hooks/useQueryAllResources";
import { IconButton, Tooltip } from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import useTranslate from "commons/hooks/useTranslate";
import { useHistory } from "react-router-dom";

const filters = [
  {
    type: "filter",
    name: "files",
    key: "file_id",
    extras: {
      optionLabel: "name",
    },
  },
  {
    type: "filter",
    name: "employees",
    key: "operator_id",
    extras: {
      optionLabel: "name",
      label: "operators",
    },
  },
  {
    type: "select",
    name: "file_type",
    key: "file_type",
    options: [
      {
        id: "normal",
        name: "normal",
      },
      {
        id: "optional",
        name: "optional",
      },
    ],
  },
];

const columns = [
  {
    name: "number",
    type: "text",
  },
  {
    name: "name",
    type: "text",
  },
  {
    name: "operator",
    type: "text",
  },
  {
    name: "file_type",
    type: "text",
  },
  {
    name: "guests_count",
    type: "number",
  },
  {
    name: "sales_count",
    type: "number",
  },
  {
    name: "sales_avg",
    type: "money",
  },
  {
    name: "sales_total",
    type: "money",
    highlight: true,
  },
  {
    name: "purchases_count",
    type: "number",
  },
  {
    name: "purchases_avg",
    type: "money",
  },
  {
    name: "purchases_total",
    type: "money",
    highlight: true,
  },
  {
    name: "profit",
    type: "money",
    highlight: true,
  },
  {
    name: "profit_percentage",
    type: "percentage",
    nominator: "profit",
    denominator: "sales_total",
    highlight: true,
  },
];

export default function FilesReport() {
  const { t } = useTranslate();
  const history = useHistory();
  const [currencies] = useQueryAllResources("currencies");

  const lookup = useMemo(
    () =>
      currencies.reduce((a, c) => {
        return {
          ...a,
          [c.id]: c.name,
        };
      }, {}),
    [currencies]
  );

  const extractCurrencyName = (records) => {
    return records.flatMap((c) => {
      return Array.isArray(c) && c.length > 0
        ? lookup[c[0].currency_id]
        : undefined;
    });
  };

  return (
    <ReportManager
      url="tourism-balance"
      title="filesReport"
      columns={columns}
      filters={filters}
      recordsFunc={(recs) => {
        return groupByCurrency(recs);
      }}
      titlesFunc={extractCurrencyName}
      totals={[
        "guests_count",
        "sales_count",
        "sales_total",
        "purchases_count",
        "purchases_total",
        "profit",
        "profit_percentage",
      ]}
      filterByDate
      initialQuery={{ type: "files" }}
      toolbarExtras={
        <Tooltip title={t("inactiveFilesReport")}>
          <IconButton
            onClick={() => history.push(`/s/reports/inactive-files/`)}
          >
            <DeleteOutline />
          </IconButton>
        </Tooltip>
      }
    />
  );
}
